import _get from 'lodash/get';

import { PRODUCT_SKU_CONFIG_KEYS as DATA_KEYS } from '../../../../../stubs';

export default function createMutationPayload(formData = {}) {
  const name = _get(formData, DATA_KEYS.NAME, '');
  const isActive = _get(formData, DATA_KEYS.IS_ACTIVE, false);
  const serviceDays = _get(formData, DATA_KEYS.SERVICE_DAYS, '');
  const startsOnDelivery = _get(formData, DATA_KEYS.STARTS_ON_DELIVERY, false);
  const products = _get(formData, DATA_KEYS.PRODUCTS, []);

  const productVariantIds = products.reduce((acc, product) => {
    const productVariants = _get(product, 'productVariants', []);
    const ids = productVariants.map(({ objectID }) => objectID);
    return acc.concat(ids);
  }, []);

  return {
    [DATA_KEYS.NAME]: name,
    [DATA_KEYS.IS_ACTIVE]: isActive,
    [DATA_KEYS.SERVICE_DAYS]: +serviceDays,
    [DATA_KEYS.STARTS_ON_DELIVERY]: startsOnDelivery,
    [DATA_KEYS.PRODUCT_VARIANTS]: productVariantIds
  };
}
